import useOffersStuff from './useOffersStuff';
import { OfferKindEnum } from '../../../services/exports/Constants';
import { selectHasCachedOrderPromoCode } from '../../../store/slices/OrderSlice';
import { useSelector } from 'react-redux';
import useGetMenuOfferHandlerByKind from './get-offer-handler/useGetMenuOfferHandlerByKind';

const useFreeItemOffer = () => {
  const hasPromoCode = useSelector(selectHasCachedOrderPromoCode);
  const { activeOffers } = useOffersStuff();
  const freeItemOffer = !hasPromoCode && activeOffers?.find((offer) => offer.kind === OfferKindEnum.FreeItemByProducts);
  const productOfferStuff = useGetMenuOfferHandlerByKind()(freeItemOffer);

  return {
    offer: freeItemOffer,
    ...productOfferStuff,
  };
};

export default useFreeItemOffer;
